import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { 
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import StudentStatusBadge from './StudentStatusBadge';
import { formatDate } from '@/lib/format';
import { useStudentEnrollments } from '@/hooks/useStudentEnrollments';

interface StudentEnrollmentsProps {
  studentId?: string;
}

const StudentEnrollments: React.FC<StudentEnrollmentsProps> = ({ studentId }) => {
  const { data: enrollments, isLoading } = useStudentEnrollments(studentId);
  
  console.log('Student ID:', studentId);
  console.log('Enrollments data:', enrollments);

  if (isLoading) {
    return <LoadingSkeleton />;
  }

  if (!enrollments || enrollments.length === 0) {
    return <EmptyState />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Type</TableHead>
          <TableHead>Name</TableHead>
          <TableHead>Level/Date</TableHead>
          <TableHead>Status</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {enrollments.map((enrollment) => (
          <TableRow key={enrollment.id}>
            <TableCell>
              {enrollment.class?.is_event ? 'Event' : 'Class'}
            </TableCell>
            <TableCell className="font-medium">
              {enrollment.class?.name || 'Unknown Class'}
            </TableCell>
            <TableCell>
              {enrollment.class?.is_event 
                ? formatEventDate(enrollment.class?.event_date)
                : (enrollment.class?.level || 'N/A')}
            </TableCell>
            <TableCell>
              <StudentStatusBadge status={enrollment.status} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const LoadingSkeleton = () => (
  <div className="space-y-2">
    <Skeleton className="h-8 w-full" />
    <Skeleton className="h-8 w-full" />
    <Skeleton className="h-8 w-full" />
  </div>
);

const EmptyState = () => (
  <div className="py-4 text-center text-muted-foreground">
    No enrollments found for this student.
  </div>
);

const formatEventDate = (dateString?: string): string => {
  if (!dateString) return 'No date';
  return formatDate(dateString);
};

export default StudentEnrollments;
